
import data from '@/assets/js/data.js'
var dataPoints=[];
data.forEach(function (item) {
  dataPoints.push([item[3],item[4]])
})

export default dataPoints




// WEBPACK FOOTER //
// ./src/assets/js/datapoints.js